import { SLUG_LEGACY_RE } from 'mk2/helpers/urls';

const POST_SLUG = `:postSlug(${SLUG_LEGACY_RE})`;

export const contestsHomeUrl = `/contests/`;
export const contestsPostDetailUrl = `/contests/${POST_SLUG}/`;
